import { Component } from 'react'
import { get } from 'lodash'

const scrollContainerId = 'scrollContainer'

export default class ScrollToTop extends Component {
  componentWillReceiveProps(nextProps) {
    const currentPath = get(this.props, 'routing.locationBeforeTransitions.pathname')
    const nextPath = get(nextProps, 'routing.locationBeforeTransitions.pathname')
    if (currentPath !== nextPath) {
      this.scrollToTop()
    }
  }
  scrollToTop = () => {
    const scrollContainer = document.getElementById(scrollContainerId)
    if (scrollContainer) {
      scrollContainer.scrollTop = 0
    }
    // Scroll top the top of the window also.
    // Window scrolling is used for mobile
    window.scrollTo(0, 0)
  }
  componentDidMount() {
    this.scrollToTop()
  }
  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Scroll/ScrollToTop/ScrollToTop.jsx